import axios from 'axios';
import { store, history } from '../redux-store';
import { paths } from "../lib";

/* eslint-disable no-undef */
const apiUrl = process.env.REACT_APP_EAPI_URL;
/* eslint-enable */

const api = axios.create({
    baseURL: apiUrl,
});

// Get cancel token for component
const getCancelToken = (component) => {
    if (!component.cancelToken) {
        // Set cancelToken in component
        component.cancelToken = new axios.CancelToken((cancel) => {
            // Set cancelRequests method of component
            component.cancelRequests = cancel;
        });
    }

    return component.cancelToken;
};

// Add the API auth token to any requests
api.interceptors.request.use(({ component, ...requestConfig }) => {
    requestConfig.headers["X-Token"] = sessionStorage.getItem('apiToken');

    if (component) {
        requestConfig.cancelToken = getCancelToken(component);
    }

    return requestConfig;
}, (error) => {
    return Promise.reject(error);
});

// Catch any unauthorised responses and log the user out
api.interceptors.response.use(null, (error) => {
    const message = error.response.data.error || "";

    if (message === "unauthorized" || message === "Unauthorized.") {
        store.dispatch({ type: "RESET" });
        sessionStorage.removeItem('apiToken');
        history.push(paths.dashboard);
    }

    return Promise.reject(error);
});

export default api;
export { apiUrl };
